export {
  initFireworks,
  cleanupFireworks,
  installAvatarCursorShadowPatch,
  uninstallAvatarCursorShadowPatch,
} from "./fireworks";
